/*
================================================

CORE SDK  —  v0.4.0 (Journey Observation)

learn()
track()
think()
identify()
interpret()

================================================
*/
(function () {
  window.Rekindle = window.Rekindle || { };

  // --------------------------------------
  // Core Architecture
  // --------------------------------------

  window.Rekindle.audience = window.Rekindle.audience || {
    identity: {},

    context: {},

    memory: {},

    intelligence: {}
  };

window.Rekindle.operations =
    window.Rekindle.operations || {

    entities: {},

    create(type, id){

        return {

            id: `${type}:${id}`,

            entity_type: type,

            identity: {},

            memory: {},

            context: {},

            intelligence: {},

            relationships: {}

        };

    },

    register(entity){

        if(!entity || !entity.id){
            return;
        }

        this.entities[entity.id] = entity;

    },

    get(id){

        return this.entities[id] || null;

    }

};
  window.Rekindle.decision = window.Rekindle.decision || {};
  // --------------------------------------
// Decision Contracts
// --------------------------------------

window.Rekindle.decision.contracts = {

    decisionInput: {

        audience: null,

        operations: null,

        experience: {

            type: "",

            entity_id: "",

            url: ""

        },

        timestamp: ""

    },

    decisionOutput: {

        version: "1.0",

        decision_id: "",

        timestamp: "",

        model: "",

        latency_ms: 0,

        confidence: 0,

        reasoning: {

            summary: "",

            signals: [],

            assumptions: []

        },

        understanding: {

            customer_intent: "",

            journey_stage: "",

            emotional_state: "",

            buying_readiness: ""

        },

        decision: {

    objective: "increase_purchase_confidence",

    next_best_action: "",

    priority: "medium"

},

        actions: [

    {

        id: "",

        type: "",

        entity_type: "",

        entity_id: "",

        confidence: 0,

        reason: ""

    }

]

    }

};
window.Rekindle.decision.state = {

    last_input: null,

    last_output: null,

    last_run: null,

    status: "idle"

};
window.Rekindle.decision.think = async function () {

    const input = structuredClone(
        window.Rekindle.decision.contracts.decisionInput
    );

    input.audience = window.Rekindle.audience;

    input.operations = window.Rekindle.operations.entities;

    input.experience = {

        type: window.Rekindle.resolveExperience(),

        entity_id: window.Rekindle.resolveEntityId(),

        url: location.pathname

    };

    input.timestamp = new Date().toISOString();

    console.log("🧠 Decision Input", input);

    window.Rekindle.decision.state.last_input = input;

    window.Rekindle.decision.state.last_run = new Date().toISOString();

    window.Rekindle.decision.state.status = "ready";

    return input;

};

window.Rekindle.decision.execute = async function () {

    const input = await window.Rekindle.decision.think();

    window.Rekindle.decision.state.status = "running";

    try {

        // TODO:
        // Send 'input' to your Make webhook
        // Receive a Decision Output

        console.log("🚀 Executing Decision", input);
        const output = structuredClone(

        window.Rekindle.decision.contracts.decisionOutput
      );

    output.version = "1.0";
    output.decision_id = crypto.randomUUID();
    output.timestamp = new Date().toISOString();
    output.model = "rekindle-decision-engine";
    output.latency_ms = 0;
    output.confidence = 0.82;

    output.understanding.customer_intent = "evaluate_product";

    output.understanding.journey_stage = "consideration";

    output.understanding.emotional_state = "curious";

    output.understanding.buying_readiness = "medium";

  window.Rekindle.decision.state.last_output = output;
  window.Rekindle.decision.state.status = "completed";

  return window.Rekindle.decision.state.last_output;

    } catch (error) {

        console.error("Decision Engine Error", error);

        window.Rekindle.decision.state.status = "error";

        throw error;

    }

};

  window.Rekindle.experience = window.Rekindle.experience || {};

  // Kernel continues here...

window.Rekindle.kernel = {
  version: "0.4.1",                    // ✅ v0.4 — was "0.4.0"
  codename: "Journey Observation",     // ✅ v0.4 — was "Intelligence Engine"
  platform: null,                      // ✅ v0.4 — detected at init (see detectPlatform), not hardcoded
  initialized: false,
  modules: {},

  register(name, module) {
    this.modules[name] = module;
  }
};
window.Rekindle.kernel.sync = {

    sequence: 0,

    last_sync: null,

    last_success: null,

    pending: false

};
window.Rekindle.audience.identity = window.Rekindle.audience.identity || {
  rekindle_id: null,
  customer: {}
};
  window.Rekindle.audience.context = window.Rekindle.audience.context || {
  acquisition: {},
  discovery: {
  channel: null,
  platform: null,
  referrer: null,
  landing_page: null,
  entry_page_title: null,
   llm: {
    detected: false,
    platform: null
  },
  utm: {
    source: null,
    medium: null,
    campaign: null,
    content: null,
    term: null
  }
},

location: {
  market: null,
  country: null,
  country_code: null,
  language: null,
  currency: null,
  timezone: null
},

browser: {
  language: null,
  languages: [],
  timezone: null,
  device_type: null,
  platform: null,
  browser: null,
  screen: {
    width: null,
    height: null
  },
  viewport: {
    width: null,
    height: null
  },
  color_scheme: null,
  touch_device: false
},

external_ids: {
  fbp: null,
  fbc: null,
  gclid: null,
  gbraid: null,
  wbraid: null,
  ga_client_id: null,
  ttclid: null,
  msclkid: null,
  li_fat_id: null,
  pin_unauth: null
},
  behaviour: {},
  interests: {},
  commerce: {
    updated_at: null,

    product: {},

    cart: {}


  },
  community: {},
  creator: {}
};
window.Rekindle.kernel.register("context", window.Rekindle.audience.context);
window.Rekindle.audience.intelligence = window.Rekindle.audience.intelligence || {
  predictions: {},
  scores: {},
  segments: {},
  recommendations: {},
  opportunities: {}
};
window.Rekindle.kernel.register("intelligence", window.Rekindle.audience.intelligence);
window.Rekindle.audience.memory = {

  session: {
    id: null,
    started_at: null,
    last_seen: null
  },

  interactions: [],

};

window.Rekindle.kernel.register("memory", window.Rekindle.audience.memory);

// --------------------------------------
// Sessions Manager
// --------------------------------------

window.Rekindle.sessions = {

  STORAGE_KEY: "rekindle_session",

  TIMEOUT: 30 * 60 * 1000, // 30 minutes

  create: function () {

    const now = new Date().toISOString();

    const session = {
      id: "rs_" + crypto.randomUUID(),
      started_at: now,
      last_seen: now,
      page_count: 0,
      sequence: 0
    };

    sessionStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify(session)
    );

    window.Rekindle.audience.memory.session = session;

    return session;
  },

  get: function () {

    const saved = sessionStorage.getItem(
      this.STORAGE_KEY
    );

    if (!saved) {
      return null;
    }

    try {
      return JSON.parse(saved);
    } catch (error) {
      console.warn(
        "⚠️ Rekindle session data invalid"
      );

      return null;
    }
  },

  isValid: function (session) {

    if (!session) {
      return false;
    }

    const lastSeen =
      new Date(session.last_seen).getTime();

    const now = Date.now();

    return (
      now - lastSeen < this.TIMEOUT
    );
  },

  start: function () {

    let session = this.get();

    if (!this.isValid(session)) {
      session = this.create();
    }

    session.last_seen =
      new Date().toISOString();

    session.sequence += 1;

    session.page_count += 1;

    sessionStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify(session)
    );

    window.Rekindle.audience.memory.session =
      session;

    console.log(
      "🧭 Rekindle Session",
      session
    );

    return session;
  },

  touch: function () {

    const session = this.get();

    if (!session) {
      return this.start();
    }

    session.last_seen =
      new Date().toISOString();

    sessionStorage.setItem(
      this.STORAGE_KEY,
      JSON.stringify(session)
    );

    window.Rekindle.audience.memory.session =
      session;

    return session;
  }

};

window.Rekindle.kernel.register(
  "sessions",
  window.Rekindle.sessions
);

// --------------------------------------
// GTM / Data Layer Bridge
// --------------------------------------

window.Rekindle.gtm = {

  push: function (event) {

    if (!event || !event.event_id) {

      console.warn(
        "⚠️ Rekindle GTM: Invalid event",
        event
      );

      return;

    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({

      event: "rekindle_event",

      rekindle_event: event,

      event_id:
        event.event_id,

      event_name:
        event.event_name,

      event_version:
        event.event_version,

      timestamp:
        event.timestamp,

      rekindle_id:
        event.actor?.rekindle_id || null,

      session_id:
        event.actor?.session_id || null,

      entity_type:
        event.entity?.type || null,

      entity_id:
        event.entity?.id || null,

      asset_type:
        event.asset?.type || null,

      asset_id:
        event.asset?.id || null,

      experience:
        event.context?.experience || null,

      page_url:
        event.context?.page_url || null,

      page_referrer:
        event.context?.page_referrer || null

    });

    console.log(
      "📡 Rekindle → GTM",
      event
    );

  }

};

window.Rekindle.kernel.register(
  "gtm",
  window.Rekindle.gtm
);
/* ============================================================
   REKINDLE SDK v0.4.1 — JOURNEY OBSERVATION LAYER

   Observe + reduce only.

   SDK observes
   → Evidence measures
   → Intelligence judges
   → Decision acts

   This layer NEVER:
   - judges journey value
   - determines statistical significance
   - chooses interventions
   - calls an LLM

   Canonical events remain in memory.interactions[].
   Journey maintains reduced journey STATE + observations.
   ============================================================ */

(function () {

  window.Rekindle = window.Rekindle || {};

  window.Rekindle.journey = {

    SCHEMA_VERSION: "1.1",

    STORAGE_KEY: "rekindle_journey",

    // Journey may span multiple sessions.
    IDLE_RESET:
      7 * 24 * 60 * 60 * 1000,

    STAGES: [
      "entry",
      "exploration",
      "consideration",
      "evaluation",
      "conversion",
      "post_purchase",
      "retention"
    ],

    // ----------------------------------------------------------
    // EVENT → JOURNEY STATE MAP
    // ----------------------------------------------------------

    MAP: {

      // Identity
      return_visit: {
        category: "identity"
      },

      identity_resolved: {
        category: "identity"
      },

      // Exploration
      page_view: {
        category: "exploration",
        counter: "page_views",
        minStage: "exploration"
      },

      collection_viewed: {
        category: "exploration",
        counter: "page_views",
        minStage: "exploration"
      },

      content_viewed: {
        category: "exploration",
        counter: "content_views",
        minStage: "exploration"
      },

      product_viewed: {
        category: "exploration",
        counter: "product_views",
        minStage: "consideration"
      },

      product_engaged: {
        category: "exploration",
        minStage: "consideration"
      },

      search_performed: {
        category: "exploration",
        counter: "searches",
        minStage: "exploration"
      },

      faq_viewed: {
        category: "exploration",
        counter: "content_views",
        minStage: "consideration"
      },

      review_viewed: {
        category: "exploration",
        minStage: "consideration"
      },

      // Recommendation
      recommendation_viewed: {
        category: "recommendation",
        counter: "recommendation_views",
        minStage: "consideration"
      },

      recommendation_clicked: {
        category: "recommendation",
        counter: "recommendation_clicks",
        minStage: "evaluation"
      },

      recommendation_dismissed: {
        category: "recommendation"
      },

      // Intent
      intent_declared: {
        category: "intent"
      },

      intent_inferred: {
        category: "intent"
      },

      // Commerce progression
      add_to_cart: {
        category: "progression",
        counter: "add_to_cart",
        minStage: "evaluation"
      },

      remove_from_cart: {
        category: "progression",
        friction: "cart_removal"
      },

      cart_viewed: {
        category: "progression",
        minStage: "evaluation"
      },

      checkout_started: {
        category: "progression",
        counter: "checkout_started",
        minStage: "evaluation"
      },

      purchase_completed: {
        category: "progression",
        counter: "purchase",
        minStage: "conversion"
      }
    },


    // ----------------------------------------------------------
    // PERSISTENCE
    // ----------------------------------------------------------

    _load: function () {

      try {

        const raw =
          localStorage.getItem(
            this.STORAGE_KEY
          );

        if (!raw) {
          return null;
        }

        const journey =
          JSON.parse(raw);

        // Do not mix old schema evidence.
        if (
          journey.journey_schema_version !==
          this.SCHEMA_VERSION
        ) {
          return null;
        }

        const lastActivity =
          new Date(
            journey.last_activity_at
          ).getTime();

        if (
          Date.now() - lastActivity >
          this.IDLE_RESET
        ) {
          return null;
        }

        return journey;

      } catch (error) {

        console.warn(
          "⚠️ Rekindle journey load failed",
          error
        );

        return null;

      }

    },


    _save: function () {

      try {

        localStorage.setItem(
          this.STORAGE_KEY,
          JSON.stringify(this.state)
        );

      } catch (error) {

        console.warn(
          "⚠️ Rekindle journey save failed",
          error
        );

      }

    },


    // ----------------------------------------------------------
    // NEW JOURNEY
    // ----------------------------------------------------------

    _newJourney: function (now) {

      const id =
        "j_" +
        (
          crypto.randomUUID
            ? crypto.randomUUID()
            : Date.now() +
              "_" +
              Math.random()
                .toString(36)
                .slice(2)
        );

      return {

        id: id,

        visitor_id: null,

        customer_id: null,

        sdk_version:
          (
            window.Rekindle.kernel &&
            window.Rekindle.kernel.version
          ) ||
          "0.4.1",

        journey_schema_version:
          this.SCHEMA_VERSION,

        platform:
          (
            window.Rekindle.kernel &&
            window.Rekindle.kernel.platform
          ) ||
          null,

        started_at: now,

        last_activity_at: now,

        ended_at: null,

        status: "active",

        session_ids: [],


        acquisition: {

          source: null,

          medium: null,

          campaign: null,

          content: null,

          landing_page: null,

          referrer: null,

          first_touch: {},

          last_touch: {}

        },


        intent: {

          value: null,

          source: null,

          confidence: 0,

          first_detected_at: null,

          last_confirmed_at: null,

          history: []

        },


        progress: {

          current_stage:
            "entry",

          highest_stage_reached:
            "entry",

          previous_stage:
            null,

          progress_score:
            0,

          transitions:
            []

        },


        behaviour: {

          events: 0,

          page_views: 0,

          product_views: 0,

          content_views: 0,

          searches: 0,

          recommendation_views: 0,

          recommendation_clicks: 0,

          add_to_cart: 0,

          checkout_started: 0,

          purchase: 0

        },


        friction: {

          signals: [],

          score: 0

        },


        recommendations: {

          shown: [],

          clicked: [],

          converted: []

        },


        outcome: {

          status: "unknown",

          order_id: null,

          revenue: 0,

          products: []

        },


        evidence: {

          observation_count: 0,

          last_observed_at: null

        }

      };

    },


    // ----------------------------------------------------------
    // JOURNEY LIFECYCLE
    // ----------------------------------------------------------

    start: function () {

      const now =
        new Date().toISOString();

      this.state =
        this._load() ||
        this._newJourney(now);


      // Identity
      const identity =
        window.Rekindle.audience
          .identity ||
        {};

      this.state.visitor_id =
        identity.rekindle_id ||
        this.state.visitor_id;

      if (
        identity.customer &&
        identity.customer.id
      ) {

        this.state.customer_id =
          String(
            identity.customer.id
          );

      }


      // Acquisition
      this._seedAcquisition();


      // Sessions
      const session =
        window.Rekindle.audience
          .memory &&
        window.Rekindle.audience
          .memory.session;

      if (
        session &&
        session.id &&
        this.state.session_ids.indexOf(
          session.id
        ) === -1
      ) {

        this.state.session_ids.push(
          session.id
        );

      }


      this.state.last_activity_at =
        now;

      this._save();

      return this.state;

    },


    _seedAcquisition: function () {

      const discovery =
        (
          window.Rekindle.audience
            .context &&
          window.Rekindle.audience
            .context.discovery
        ) ||
        {};

      const acquisition =
        this.state.acquisition;

      const touch = {

        source:
          (
            discovery.utm &&
            discovery.utm.source
          ) ||
          discovery.channel ||
          null,

        medium:
          (
            discovery.utm &&
            discovery.utm.medium
          ) ||
          null,

        campaign:
          (
            discovery.utm &&
            discovery.utm.campaign
          ) ||
          null,

        content:
          (
            discovery.utm &&
            discovery.utm.content
          ) ||
          null,

        landing_page:
          discovery.landing_page ||
          null,

        referrer:
          discovery.referrer ||
          null

      };


      const haveSignal =
        touch.source ||
        touch.referrer ||
        touch.landing_page;


      // First touch is immutable.
      if (
        this._isEmpty(
          acquisition.first_touch
        ) &&
        haveSignal
      ) {

        acquisition.first_touch =
          Object.assign(
            {},
            touch
          );

      }


      acquisition.last_touch =
        Object.assign(
          {},
          touch
        );


      [
        "source",
        "medium",
        "campaign",
        "content",
        "landing_page",
        "referrer"
      ].forEach(
        function (key) {

          if (
            acquisition[key] == null &&
            touch[key] != null
          ) {

            acquisition[key] =
              touch[key];

          }

        }
      );

    },


    // ----------------------------------------------------------
    // OBSERVE
    // ----------------------------------------------------------

    observe: function (
      eventOrName,
      maybeData
    ) {

      if (!this.state) {
        this.start();
      }


      let name;

      let data;

      let actor;

      let context;


      // Manual form:
      // journey.observe("intent_declared", {...})
      if (
        typeof eventOrName ===
        "string"
      ) {

        name =
          eventOrName;

        data =
          maybeData ||
          {};

        actor =
          {};

        context =
          {};

      } else {

        const event =
          eventOrName ||
          {};

        name =
          event.event_name;

        data =
          Object.assign(
            {},
            event.properties,
            event.entity &&
              event.entity.properties,
            {

              entity_type:
                event.entity &&
                event.entity.type,

              entity_id:
                event.entity &&
                event.entity.id,

              entity_name:
                event.entity &&
                event.entity.name

            }
          );

        actor =
          event.actor ||
          {};

        context =
          event.context ||
          {};

      }


      const now =
        new Date().toISOString();

      const spec =
        this.MAP[name];


      // Never throw away unknown evidence.
      if (!spec) {

        return this._record(
          name,
          data,
          now,
          actor,
          context,
          {
            unknown: true
          }
        );

      }


      this.state.last_activity_at =
        now;

      this.state.behaviour.events +=
        1;


      if (spec.counter) {

        this.state.behaviour[
          spec.counter
        ] += 1;

      }


      if (spec.minStage) {

        this._advance(
          spec.minStage,
          now
        );

      }


      this._applyDomain(
        name,
        data,
        now
      );


      if (spec.friction) {

        this._addFriction(
          spec.friction,
          data
        );

      }


      this._deriveFriction();


      const observation =
        this._record(
          name,
          data,
          now,
          actor,
          context,
          {
            category:
              spec.category
          }
        );


      this._save();

      return observation;

    },


    // ----------------------------------------------------------
    // DOMAIN REDUCERS
    // ----------------------------------------------------------

    _applyDomain: function (
      name,
      data,
      now
    ) {

      const journey =
        this.state;


      switch (name) {

        case "identity_resolved":

          journey.customer_id =
            data.entity_id ||
            journey.customer_id;

          break;


        case "intent_declared":

          this.updateIntent(
            data.value ||
              data.intent_value,
            "declared",
            1.0,
            now
          );

          break;


        case "intent_inferred":

          this.updateIntent(
            data.value ||
              data.intent_value,
            "inferred",
            data.confidence != null
              ? data.confidence
              : 0.5,
            now
          );

          break;


        case "recommendation_viewed":

          journey.recommendations
            .shown.push(
              this._recRef(
                data,
                now
              )
            );

          break;


        case "recommendation_clicked":

          journey.recommendations
            .clicked.push(
              this._recRef(
                data,
                now
              )
            );

          break;


        case "purchase_completed":

          journey.status =
            "converted";

          journey.outcome = {

            status:
              "converted",

            order_id:
              data.order_id ||
              null,

            revenue:
              data.revenue ||
              data.total_price ||
              0,

            products:
              data.products ||
              data.product_ids ||
              []

          };


          // Recommendation → purchase linkage.
          const bought =
            journey.outcome
              .products
              .map(String);


          journey.recommendations
            .clicked
            .forEach(
              function (recommendation) {

                if (
                  recommendation.product_id &&
                  bought.indexOf(
                    String(
                      recommendation.product_id
                    )
                  ) !== -1
                ) {

                  journey.recommendations
                    .converted.push(
                      recommendation
                    );

                }

              }
            );

          break;

      }

    },


    // ----------------------------------------------------------
    // INTENT
    // ----------------------------------------------------------

    updateIntent: function (
      value,
      source,
      confidence,
      now
    ) {

      if (value == null) {
        return this.state.intent;
      }


      now =
        now ||
        new Date().toISOString();


      const current =
        this.state.intent;


      const rank =
        function (intentSource) {

          if (
            intentSource ===
            "declared"
          ) {
            return 2;
          }

          if (
            intentSource ===
            "inferred"
          ) {
            return 1;
          }

          return 0;

        };


      const stronger =
        rank(source) >
        rank(current.source);


      const sameOrBetter =
        rank(source) ===
          rank(current.source) &&
        confidence >=
          current.confidence;


      if (
        current.value == null ||
        stronger ||
        sameOrBetter ||
        value !== current.value
      ) {

        if (
          current.value != null &&
          current.value !== value
        ) {

          current.history.push({

            value:
              current.value,

            source:
              current.source,

            confidence:
              current.confidence,

            until:
              now

          });

        }


        current.value =
          value;

        current.source =
          source;

        current.confidence =
          source === "declared"
            ? 1.0
            : confidence;

        current.first_detected_at =
          current.first_detected_at ||
          now;

        current.last_confirmed_at =
          now;

      }


      this._save();

      return current;

    },


    declareIntent: function (value) {

      this.updateIntent(
        value,
        "declared",
        1.0
      );

      return this.state.intent;

    },


    // ----------------------------------------------------------
    // PROGRESSION
    // ----------------------------------------------------------

    progress: function (stage) {

      return this._advance(
        stage,
        new Date().toISOString()
      );

    },


    _advance: function (
      toStage,
      now
    ) {

      const journey =
        this.state;


      if (
        this.STAGES.indexOf(
          toStage
        ) === -1
      ) {

        return journey.progress;

      }


      if (
        this.STAGES.indexOf(
          toStage
        ) <=
        this.STAGES.indexOf(
          journey.progress.current_stage
        )
      ) {

        return journey.progress;

      }


      journey.progress
        .transitions
        .push({

          from:
            journey.progress
              .current_stage,

          to:
            toStage,

          timestamp:
            now

        });


      journey.progress.previous_stage =
        journey.progress.current_stage;


      journey.progress.current_stage =
        toStage;


      journey.progress
        .highest_stage_reached =
        toStage;


      journey.progress.progress_score =
        Math.max(

          journey.progress
            .progress_score,

          this.STAGES.indexOf(
            toStage
          ) /
          (
            this.STAGES.length -
            1
          )

        );


      return journey.progress;

    },


    // ----------------------------------------------------------
    // FRICTION
    // ----------------------------------------------------------

    _deriveFriction: function () {

      const behaviour =
        this.state.behaviour;


      if (
        behaviour.product_views >=
          5 &&
        behaviour.add_to_cart ===
          0
      ) {

        this._addFriction(
          "repeated_product_evaluation",
          {
            product_views:
              behaviour.product_views
          }
        );

      }


      if (
        behaviour.searches >=
          3 &&
        behaviour.product_views ===
          0
      ) {

        this._addFriction(
          "unproductive_search",
          {
            searches:
              behaviour.searches
          }
        );

      }

    },


    _addFriction: function (
      type,
      data
    ) {

      const signals =
        this.state.friction
          .signals;


      for (
        let index = 0;
        index < signals.length;
        index++
      ) {

        if (
          signals[index].type ===
          type
        ) {
          return;
        }

      }


      signals.push({

        type:
          type,

        data:
          data ||
          {},

        at:
          new Date().toISOString()

      });


      this.state.friction.score =
        signals.length;

    },


    // ----------------------------------------------------------
    // PUBLIC STATE
    // ----------------------------------------------------------

    getState: function () {

      const journey =
        this.state;


      return {

        journey_id:
          journey.id,

        stage:
          journey.progress
            .current_stage,

        highest_stage_reached:
          journey.progress
            .highest_stage_reached ||
          journey.progress
            .current_stage,

        intent:
          journey.intent.value,

        intent_confidence:
          journey.intent.confidence,

        progress_score:
          Math.round(
            journey.progress
              .progress_score *
            100
          ) /
          100,

        status:
          journey.status

      };

    },


    getJourney: function () {

      return this.state;

    },


    end: function (reason) {

      const now =
        new Date().toISOString();


      this.state.ended_at =
        now;


      this.state.status =
        this.state.status ===
          "converted"
          ? "converted"
          : "ended";


      this._save();


      return this._record(
        "journey_ended",
        {
          reason:
            reason ||
            "timeout"
        },
        now,
        {},
        {}
      );

    },


    // ----------------------------------------------------------
    // NORMALIZED OBSERVATION RECORD
    // ----------------------------------------------------------

    _record: function (
      name,
      data,
      now,
      actor,
      context,
      extra
    ) {

      extra =
        extra ||
        {};


      const journey =
        this.state;


      journey.evidence
        .observation_count +=
        1;


      journey.evidence
        .last_observed_at =
        now;


      const observation = {

        observation_id:
          "jo_" +
          (
            crypto.randomUUID
              ? crypto.randomUUID()
              : Date.now() +
                "_" +
                Math.random()
                  .toString(36)
                  .slice(2)
          ),

        journey_id:
          journey.id,

        timestamp:
          now,

        sdk_version:
          journey.sdk_version,

        journey_schema_version:
          journey.journey_schema_version,


        event: {

          name:
            name,

          category:
            extra.category ||
            (
              this.MAP[name] &&
              this.MAP[name]
                .category
            ) ||
            "other"

        },


        actor: {

          visitor_id:
            journey.visitor_id,

          customer_id:
            journey.customer_id,

          session_id:
            (
              actor &&
              actor.session_id
            ) ||
            null

        },


        context: {

          page:
            (
              context &&
              context.page_url
            ) ||
            (
              typeof location !==
              "undefined"
                ? location.pathname
                : null
            ),

          experience:
            (
              context &&
              context.experience
            ) ||
            null,


          // Generic entity
          entity_type:
            data.entity_type ||
            null,

          entity_id:
            data.entity_id ||
            null,


          // Typed entity IDs
          product_id:
            data.product_id ||
            (
              data.entity_type ===
              "product"
                ? data.entity_id
                : null
            ),

          collection_id:
            data.collection_id ||
            (
              data.entity_type ===
              "collection"
                ? data.entity_id
                : null
            ),

          content_id:
            data.content_id ||
            (
              data.entity_type ===
              "content"
                ? data.entity_id
                : null
            ),

          recommendation_set_id:
            data.recommendation_set_id ||
            (
              data.entity_type ===
              "recommendation_set"
                ? data.entity_id
                : null
            ) ||
            data.recommendation_id ||
            null

        },


        data:
          data ||
          {},


        journey_state:
          this.getState(),


        acquisition: {

          source:
            journey.acquisition.source,

          medium:
            journey.acquisition.medium

        },


        unknown_event:
          extra.unknown
            ? true
            : undefined

      };


      // Emit normalized observation to GTM.
      if (
        window.Rekindle.gtm &&
        observation.event.name !==
          "journey_ended"
      ) {

        try {

          window.dataLayer =
            window.dataLayer ||
            [];


          window.dataLayer.push({

            event:
              "rekindle_observation",

            rekindle_observation:
              observation

          });

        } catch (error) {

          console.warn(
            "⚠️ Rekindle observation GTM push failed",
            error
          );

        }

      }


      return observation;

    },


    // ----------------------------------------------------------
    // DAILY OBSERVATION SUMMARY
    // ----------------------------------------------------------

    dailySummary: function (date) {

      const journey =
        this.state;


      return {

        date:
          date,

        journey_id:
          journey.id,

        sdk_version:
          journey.sdk_version,

        journey_schema_version:
          journey.journey_schema_version,


        observation_summary: {

          sessions:
            journey.session_ids
              .length ||
            1,

          events:
            journey.behaviour.events,


          acquisition: {

            source:
              journey.acquisition.source,

            medium:
              journey.acquisition.medium

          },


          intents:
            journey.intent.value
              ? [
                  {
                    value:
                      journey.intent.value,

                    source:
                      journey.intent.source,

                    confidence:
                      journey.intent
                        .confidence
                  }
                ]
              : [],


          progression: {

            starting_stage:
              (
                journey.progress
                  .transitions[0] &&
                journey.progress
                  .transitions[0]
                  .from
              ) ||
              journey.progress
                .current_stage,

            ending_stage:
              journey.progress
                .current_stage,

            highest_stage_reached:
              journey.progress
                .highest_stage_reached ||
              journey.progress
                .current_stage,

            transitions:
              journey.progress
                .transitions.length

          },


          recommendations: {

            viewed:
              journey.behaviour
                .recommendation_views,

            clicked:
              journey.behaviour
                .recommendation_clicks,

            converted:
              journey.recommendations
                .converted.length

          },


          friction:
            journey.friction
              .signals
              .map(
                function (signal) {
                  return signal.type;
                }
              ),


          outcomes: {

            purchase:
              journey.behaviour
                .purchase >
              0,

            revenue:
              journey.outcome.revenue

          }

        }

      };

    },


    // ----------------------------------------------------------
    // RECOMMENDATION REFERENCE
    // ----------------------------------------------------------

    _recRef: function (
      data,
      now
    ) {

      return {

        recommendation_set_id:
          data.recommendation_set_id ||
          (
            data.entity_type ===
            "recommendation_set"
              ? data.entity_id
              : null
          ) ||
          data.recommendation_id ||
          null,


        product_id:
          data.product_id ||
          (
            data.entity_type ===
            "product"
              ? data.entity_id
              : null
          ),


        entity_type:
          data.entity_type ||
          null,

        entity_id:
          data.entity_id ||
          null,

        context:
          data.recommendation_context ||
          null,

        at:
          now

      };

    },


    _isEmpty: function (object) {

      return (
        !object ||
        Object.keys(object).length ===
          0
      );

    }

  };


  if (
    window.Rekindle.kernel &&
    window.Rekindle.kernel.register
  ) {

    window.Rekindle.kernel.register(
      "journey",
      window.Rekindle.journey
    );

  }

})();
// --------------------------------------
// Audience Identity
// --------------------------------------

window.Rekindle.getRekindleId = function () {

  const STORAGE_KEY = "rekindle_id";

  let id = localStorage.getItem(STORAGE_KEY);

  if (!id) {

    if (window.crypto && crypto.randomUUID) {
      id = "rk_" + crypto.randomUUID();
    } else {
      id =
        "rk_" +
        Date.now() +
        "_" +
        Math.random().toString(36).substring(2, 10);
    }

    localStorage.setItem(STORAGE_KEY, id);

  }
window.Rekindle.audience.identity.rekindle_id = id;

window.Rekindle.audience.context.identity = undefined;
  return id;

};
// --------------------------------------
// Platform Detection  ✅ v0.4
// Keeps the SDK platform-agnostic: the core observes the same way
// everywhere; only this function knows how to recognise each host.
// Add new hosts here — nothing else in the core needs to change.
// --------------------------------------
window.Rekindle.detectPlatform = function () {
  try {
    if (window.Shopify || document.querySelector("[data-shopify]")) return "shopify";
    if (window.woocommerce_params || (document.body && document.body.classList.contains("woocommerce"))) return "woocommerce";
    if (window.BCData || window.bcData) return "bigcommerce";
    if (window.Static && window.Static.SQUARESPACE_CONTEXT) return "squarespace";
    if (window.wixEmbedsAPI || window.wixPerformanceMeasurements) return "wix";
    if (window.Ecwid) return "ecwid";
  } catch (e) {}
  return "custom";
};
 window.Rekindle.learn = function (data) {

  Object.keys(data).forEach(function (section) {

    if (!window.Rekindle.audience.context[section]) {
      window.Rekindle.audience.context[section] = {};
    }

    Object.keys(data[section]).forEach(function (key) {
      window.Rekindle.audience.context[section][key] =
        data[section][key];
    });

  });

  localStorage.setItem(
    "rekindle_context",
    JSON.stringify(window.Rekindle.audience.context)
  );

  console.log("📦 Context Updated", window.Rekindle.audience.context);

};
  window.Rekindle.recordInteraction = function (eventName, properties = {}) {

  const timestamp = new Date().toISOString();

  const session =
    window.Rekindle.audience.memory.session;

  const identity =
    window.Rekindle.audience.identity;

  const experience =
    properties.experience ||
    window.Rekindle.resolveExperience();

  const event = {

    event_id: crypto.randomUUID(),

    event_name: eventName,

    event_version: "1.0",

    timestamp: timestamp,

    actor: {

      rekindle_id:
        window.Rekindle.getRekindleId(),

      anonymous_id:
        properties.anonymous_id || null,

      customer_id:
        identity.customer?.id || null,

      session_id:
        session?.id || null

    },

    entity: {

      type:
        properties.entity_type || null,

      id:
        properties.entity_id || null,

      name:
        properties.entity_name || null,

      properties:
        properties.entity_properties || {}

    },

    asset: {

      type: "website",

      id:
        window.Shopify?.shop || null,

      platform: window.Rekindle.kernel.platform   // ✅ v0.4 — detected, not hardcoded

    },

    context: {

      experience: experience,

      page_url:
        location.pathname,

      page_referrer:
        document.referrer || null,

      device:
        window.Rekindle.audience.context
          .browser?.device_type || null

    },

    properties:
      properties.event_properties || {},

    source: {

      type: "rekindle_sdk",

      sdk_version:
        window.Rekindle.kernel.version

    }

  };

  console.log("📍 Rekindle Event:", event);

  // Update latest behavioural state
  window.Rekindle.learn({

    behaviour: {

      last_event:
        eventName,

      last_seen:
        timestamp,

      last_properties:
        properties

    }

  });

  // Store canonical event in memory (immutable history)
  window.Rekindle.audience.memory.interactions.push(
    event
  );

  // ✅ v0.4 — reduce this event into Journey State (observation layer).
  // Observes only; never judges. Failures must never break tracking.
  if (window.Rekindle.journey) {
    try {
      window.Rekindle.journey.observe(event);
    } catch (e) {
      console.warn("⚠️ Rekindle journey.observe failed", e);
    }
  }

  return event;

};
window.Rekindle.thinkCommerce = function () {

  const commerce = window.Rekindle.audience.context.commerce;

  if (!commerce || !commerce.cart) return;

  window.Rekindle.audience.intelligence.scores =
    window.Rekindle.audience.intelligence.scores || {};

  window.Rekindle.audience.intelligence.scores.cart_value =
    commerce.cart.total_price;

  window.Rekindle.audience.intelligence.scores.item_count =
    commerce.cart.item_count;

  window.Rekindle.audience.intelligence.scores.average_item_value =
    commerce.cart.item_count > 0
      ? commerce.cart.total_price / commerce.cart.item_count
      : 0;

};
window.Rekindle.think = async function () {

  window.Rekindle.thinkCommerce();
  await window.Rekindle.decision.think();

  console.log(
    "🧠 Intelligence Updated",
    window.Rekindle.audience.intelligence
  );

};

window.Rekindle.touchContext = function (section) {

    if (!window.Rekindle.audience.context || !window.Rekindle.audience.context[section]) {
        return;
    }

    window.Rekindle.audience.context[section].updated_at =
        new Date().toISOString();

};
window.Rekindle.collectEnvironment = function () {
    window.Rekindle.collectDiscovery();

    window.Rekindle.collectBrowser();

    window.Rekindle.collectLocation();

    window.Rekindle.collectExternalIds();
 };

window.Rekindle.collectDiscovery = function () {

 if (!window.Rekindle.audience.context.discovery) {
  window.Rekindle.audience.context.discovery = {};
}

if (!window.Rekindle.audience.context.discovery.utm) {
  window.Rekindle.audience.context.discovery.utm = {};
}

const url = new URL(window.location.href);
const params = url.searchParams;

if (!window.Rekindle.audience.context.discovery.referrer) {
  window.Rekindle.audience.context.discovery.referrer =
    document.referrer || null;
}

if (!window.Rekindle.audience.context.discovery.landing_page) {
  window.Rekindle.audience.context.discovery.landing_page =
    window.location.pathname;
}
window.Rekindle.audience.context.discovery.entry_page_title = document.title || null;

window.Rekindle.audience.context.discovery.utm.source = params.get("utm_source");

window.Rekindle.audience.context.discovery.utm.medium = params.get("utm_medium");

window.Rekindle.audience.context.discovery.utm.campaign = params.get("utm_campaign");

window.Rekindle.audience.context.discovery.utm.content = params.get("utm_content");

window.Rekindle.audience.context.discovery.utm.term = params.get("utm_term");

const referrer = (document.referrer || "").toLowerCase();

if (!referrer) {
  window.Rekindle.audience.context.discovery.channel = "Direct";
} else if (
  referrer.includes("google.") ||
  referrer.includes("bing.") ||
  referrer.includes("yahoo.") ||
  referrer.includes("duckduckgo.")
) {
  window.Rekindle.audience.context.discovery.channel = "Search";
} else if (
  referrer.includes("facebook.") ||
  referrer.includes("instagram.") ||
  referrer.includes("linkedin.") ||
  referrer.includes("x.com") ||
  referrer.includes("twitter.") ||
  referrer.includes("tiktok.") ||
  referrer.includes("pinterest.")
) {
  window.Rekindle.audience.context.discovery.channel = "Social";
} else if (
  referrer.includes("chatgpt.com") ||
  referrer.includes("perplexity.ai") ||
  referrer.includes("claude.ai") ||
  referrer.includes("gemini.google.com") ||
  referrer.includes("copilot.microsoft.com") ||
  referrer.includes("poe.com")
) {
  window.Rekindle.audience.context.discovery.channel = "LLM";
} else {
  window.Rekindle.audience.context.discovery.channel = "Referral";
}

if (referrer.includes("chatgpt.com")) {
  window.Rekindle.audience.context.discovery.platform = "ChatGPT";
} else if (referrer.includes("perplexity.ai")) {
  window.Rekindle.audience.context.discovery.platform = "Perplexity";
} else if (referrer.includes("claude.ai")) {
  window.Rekindle.audience.context.discovery.platform = "Claude";
} else if (referrer.includes("gemini.google.com")) {
  window.Rekindle.audience.context.discovery.platform = "Gemini";
} else if (referrer.includes("copilot.microsoft.com")) {
  window.Rekindle.audience.context.discovery.platform = "Copilot";
} else if (referrer.includes("poe.com")) {
  window.Rekindle.audience.context.discovery.platform = "Poe";
} else if (referrer.includes("google.")) {
  window.Rekindle.audience.context.discovery.platform = "Google";
} else if (referrer.includes("bing.")) {
  window.Rekindle.audience.context.discovery.platform = "Bing";
} else if (referrer.includes("facebook.")) {
  window.Rekindle.audience.context.discovery.platform = "Facebook";
} else if (referrer.includes("instagram.")) {
  window.Rekindle.audience.context.discovery.platform = "Instagram";
} else if (referrer.includes("linkedin.")) {
  window.Rekindle.audience.context.discovery.platform = "LinkedIn";
} else if (referrer.includes("x.com") || referrer.includes("twitter.")) {
  window.Rekindle.audience.context.discovery.platform = "X";
} else if (referrer.includes("tiktok.")) {
  window.Rekindle.audience.context.discovery.platform = "TikTok";
} else if (referrer.includes("pinterest.")) {
  window.Rekindle.audience.context.discovery.platform = "Pinterest";
} else {
  window.Rekindle.audience.context.discovery.platform = null;
}
};

window.Rekindle.collectBrowser = function () {

  const context = window.Rekindle.audience.context;

  if (!context.browser) {
    context.browser = {};
  }

  if (!context.browser.screen) {
    context.browser.screen = {};
  }

  if (!context.browser.viewport) {
    context.browser.viewport = {};
  }

  const browser = context.browser;

  browser.language = navigator.language || null;
  browser.languages = navigator.languages || [];

  browser.timezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || null;

  browser.platform = navigator.platform || null;

  browser.screen.width = screen.width || null;
  browser.screen.height = screen.height || null;

  browser.viewport.width = window.innerWidth || null;
  browser.viewport.height = window.innerHeight || null;

  browser.touch_device =
    navigator.maxTouchPoints > 0 ||
    "ontouchstart" in window;

  browser.color_scheme =
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";

  const ua = navigator.userAgent;

  if (/Edg/i.test(ua)) {
    browser.browser = "Edge";
  } else if (/Chrome/i.test(ua) && !/Edg/i.test(ua)) {
    browser.browser = "Chrome";
  } else if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) {
    browser.browser = "Safari";
  } else if (/Firefox/i.test(ua)) {
    browser.browser = "Firefox";
  } else {
    browser.browser = "Unknown";
  }

  if (window.innerWidth < 768) {
    browser.device_type = "Mobile";
  } else if (window.innerWidth < 1024) {
    browser.device_type = "Tablet";
  } else {
    browser.device_type = "Desktop";
  }

};

window.Rekindle.collectLocation = function () {

  const context = window.Rekindle.audience.context;

  if (!context.location) {
    context.location = {};
  }

  const location = context.location;

  location.language =
    document.documentElement.lang || navigator.language || null;

  location.timezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || null;

  if (window.Shopify && Shopify.currency) {
    location.currency = Shopify.currency.active;
  }

  if (window.Shopify && Shopify.country) {
    location.country = Shopify.country;
  }

  if (window.Shopify && Shopify.locale) {
    location.language = Shopify.locale;
  }

};
window.Rekindle.getCookie = function (name) {

  const value = `; ${document.cookie}`;

  const parts = value.split(`; ${name}=`);

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }

  return null;

};
window.Rekindle.collectExternalIds = function () {

  const context = window.Rekindle.audience.context;

  if (!context.external_ids) {
    context.external_ids = {};
  }

  const externalIds = context.external_ids;
  const params = new URLSearchParams(window.location.search);

  externalIds.fbp = window.Rekindle.getCookie("_fbp");
  externalIds.fbc = window.Rekindle.getCookie("_fbc");

  externalIds.gclid = params.get("gclid");
  externalIds.gbraid = params.get("gbraid");
  externalIds.wbraid = params.get("wbraid");

  externalIds.ttclid = params.get("ttclid");
  externalIds.msclkid = params.get("msclkid");

  externalIds.li_fat_id = window.Rekindle.getCookie("li_fat_id");

  externalIds.pin_unauth = window.Rekindle.getCookie("_pin_unauth");

  externalIds.ga_client_id = window.Rekindle.getCookie("_ga");

};

window.Rekindle.resolveExperience = function () {

    if (location.pathname.startsWith("/products/")) {
        return "product_page";
    }

    if (location.pathname === "/") {
        return "home_page";
    }

    if (location.pathname.startsWith("/collections/")) {
        return "collection_page";
    }

    if (location.pathname === "/cart") {
        return "cart_page";
    }

    if (location.pathname.startsWith("/blogs/")) {
        return "blog_page";
    }

    if (location.pathname.startsWith("/pages/brand")) {
        return "brand_page";
    }

    return "generic_page";

};

window.Rekindle.resolveEntityId = function () {

    const experience = window.Rekindle.resolveExperience();

    switch (experience) {

        case "home_page":
            return "home";

        case "product_page":
            return window.meta?.product?.handle || location.pathname;

        case "collection_page":
            return location.pathname.split("/collections/")[1] || location.pathname;

        case "blog_page":
            return location.pathname.split("/blogs/")[1] || location.pathname;

        case "cart_page":
            return "cart";

        case "page":
            return location.pathname.split("/pages/")[1] || location.pathname;

        default:
            return location.pathname;

    }

};
// --------------------------------------
// Phase 1 — Collection Viewed
// --------------------------------------

window.Rekindle.trackCollectionView = function () {

  const experience =
    window.Rekindle.resolveExperience();

  if (experience !== "collection_page") {
    return null;
  }

  const collectionId =
    window.Rekindle.resolveEntityId();

  const collectionTitle =
    document.querySelector("h1")?.textContent.trim() || null;

  return window.Rekindle.recordInteraction(
    "collection_viewed",
    {

      entity_type: "collection",

      entity_id: collectionId,

      entity_name: collectionTitle,

      event_properties: {

        collection_title:
          collectionTitle,

        url:
          location.pathname

      }

    }
  );

};
// --------------------------------------
// Phase 1 — Product Viewed
// --------------------------------------

window.Rekindle.trackProductView = function () {

  const experience =
    window.Rekindle.resolveExperience();

  if (experience !== "product_page") {
    return null;
  }

  const product =
    window.Rekindle.audience.context.commerce?.product;

  if (!product) {
    return null;
  }

  return window.Rekindle.recordInteraction(
    "product_viewed",
    {

      entity_type: "product",

      entity_id:
        product.handle || product.id,

      entity_name:
        product.title || null,

      event_properties: {

        product_id:
          product.id || null,

        product_gid:
          product.gid || null,

        product_handle:
          product.handle || null,

        vendor:
          product.vendor || null,

        product_type:
          product.type || null,

        url:
          location.pathname

      }

    }
  );

};
// --------------------------------------
// Phase 1 — Search Performed
// --------------------------------------

window.Rekindle.trackSearchPerformed = function () {

  const path =
    window.location.pathname;

  if (path !== "/search") {
    return null;
  }

  const params =
    new URLSearchParams(window.location.search);

  const query =
    params.get("q");

  if (!query) {
    return null;
  }

  const decodedQuery =
    query.trim();

  if (!decodedQuery) {
    return null;
  }

  return window.Rekindle.recordInteraction(
    "search_performed",
    {

      entity_type: "search",

      entity_id: decodedQuery.toLowerCase(),

      entity_name: decodedQuery,

      event_properties: {

        query: decodedQuery,

        result_url:
          window.location.pathname +
          window.location.search

      }

    }
  );

};
// ============================================================
// PHASE 1 — REMAINING BEHAVIOURAL SIGNALS
// ============================================================

window.Rekindle.phase1 = window.Rekindle.phase1 || {};

window.Rekindle.phase1.emit = function (
  eventName,
  properties = {}
) {

  const event =
    window.Rekindle.recordInteraction(
      eventName,
      properties
    );

  if (event) {
    window.Rekindle.gtm.push(event);
  }

  return event;
};


// ------------------------------------------------------------
// RETURN VISIT
// ------------------------------------------------------------

window.Rekindle.phase1.trackReturnVisit = function () {

  const key = "rekindle_return_visit";

  const previousVisit =
    localStorage.getItem(key);

  const now =
    new Date().toISOString();

  localStorage.setItem(key, now);

  if (!previousVisit) {
    return null;
  }

  return window.Rekindle.phase1.emit(
    "return_visit",
    {
      entity_type: "visitor",
      entity_id:
        window.Rekindle.getRekindleId(),

      event_properties: {

        previous_visit:
          previousVisit,

        current_visit:
          now

      }
    }
  );

};


// ------------------------------------------------------------
// IDENTITY RESOLVED
// ------------------------------------------------------------

window.Rekindle.phase1.trackIdentityResolved = function () {

  const customer =
    window.Rekindle.audience.identity?.customer;

  if (!customer?.id) {
    return null;
  }

  const identityKey =
    "rekindle_identity_resolved";

  const lastResolved =
    sessionStorage.getItem(identityKey);

  if (lastResolved === String(customer.id)) {
    return null;
  }

  sessionStorage.setItem(
    identityKey,
    String(customer.id)
  );

  return window.Rekindle.phase1.emit(
    "identity_resolved",
    {

      entity_type: "customer",

      entity_id:
        String(customer.id),

      event_properties: {

        logged_in: true

      }

    }
  );

};


// ------------------------------------------------------------
// CART VIEWED
// ------------------------------------------------------------

window.Rekindle.phase1.trackCartViewed = function () {

  if (
    window.Rekindle.resolveExperience() !==
    "cart_page"
  ) {
    return null;
  }

  const cart =
    window.Rekindle.audience.context
      ?.commerce?.cart;

  return window.Rekindle.phase1.emit(
    "cart_viewed",
    {

      entity_type: "cart",

      entity_id:
        cart?.token || "cart",

      event_properties: {

        item_count:
          cart?.item_count || 0,

        total_price:
          cart?.total_price || 0,

        currency:
          cart?.currency || null

      }

    }
  );

};


// ------------------------------------------------------------
// ADD TO CART
// ------------------------------------------------------------

window.Rekindle.phase1.trackAddToCart = function (
  item
) {

  if (!item) {
    return null;
  }

  return window.Rekindle.phase1.emit(
    "add_to_cart",
    {

      entity_type: "product",

      entity_id:
        item.product_id ||
        item.variant_id ||
        null,

      entity_properties: {

        variant_id:
          item.variant_id || null,

        product_id:
          item.product_id || null,

        title:
          item.title ||
          item.product_title ||
          null,

        quantity:
          item.quantity || 1,

        price:
          item.price || null

      }

    }
  );

};


// ------------------------------------------------------------
// REMOVE FROM CART
// ------------------------------------------------------------

window.Rekindle.phase1.trackRemoveFromCart = function (
  item
) {

  if (!item) {
    return null;
  }

  return window.Rekindle.phase1.emit(
    "remove_from_cart",
    {

      entity_type: "product",

      entity_id:
        item.product_id ||
        item.variant_id ||
        null,

      entity_properties: {

        variant_id:
          item.variant_id || null,

        product_id:
          item.product_id || null,

        title:
          item.title ||
          item.product_title ||
          null,

        quantity:
          item.quantity || 1

      }

    }
  );

};


// ------------------------------------------------------------
// CHECKOUT STARTED
// ------------------------------------------------------------

window.Rekindle.phase1.trackCheckoutStarted =
  function () {

    return window.Rekindle.phase1.emit(
      "checkout_started",
      {

        entity_type: "checkout",

        entity_id:
          window.Rekindle.audience.context
            ?.commerce?.cart?.token ||
          null,

        event_properties: {

          item_count:
            window.Rekindle.audience.context
              ?.commerce?.cart?.item_count || 0,

          total_price:
            window.Rekindle.audience.context
              ?.commerce?.cart?.total_price || 0

        }

      }
    );

  };


// ------------------------------------------------------------
// PRODUCT ENGAGED
// ------------------------------------------------------------

window.Rekindle.phase1.trackProductEngaged =
  function (
    interaction,
    properties = {}
  ) {

    const experience =
      window.Rekindle.resolveExperience();

    if (experience !== "product_page") {
      return null;
    }

    const product =
      window.Rekindle.audience.context
        ?.commerce?.product;

    if (!product) {
      return null;
    }

    return window.Rekindle.phase1.emit(
      "product_engaged",
      {

        entity_type: "product",

        entity_id:
          product.handle ||
          product.id,

        entity_name:
          product.title || null,

        event_properties: {

          interaction:
            interaction,

          ...properties

        }

      }
    );

  };


// ------------------------------------------------------------
// CONTENT VIEWED
// ------------------------------------------------------------

window.Rekindle.phase1.trackContentViewed =
  function () {

    const experience =
      window.Rekindle.resolveExperience();

    if (experience !== "blog_page") {
      return null;
    }

    return window.Rekindle.phase1.emit(
      "content_viewed",
      {

        entity_type: "content",

        entity_id:
          location.pathname,

        event_properties: {

          content_type: "blog",

          url:
            location.pathname

        }

      }
    );

  };


// ------------------------------------------------------------
// RECOMMENDATION CLICKED
// ------------------------------------------------------------

window.Rekindle.phase1.trackRecommendationClicked =
  function (entity = {}) {

    return window.Rekindle.phase1.emit(
      "recommendation_clicked",
      {

        entity_type:
          entity.entity_type ||
          "product",

        entity_id:
          entity.entity_id ||
          null,

        event_properties: {

          recommendation_id:
            entity.recommendation_id ||
            null,

          source:
            entity.source ||
            null

        }

      }
    );

  };


// ------------------------------------------------------------
// RECOMMENDATION VIEWED
// ------------------------------------------------------------

window.Rekindle.phase1.trackRecommendationViewed =
  function (entity = {}) {

    return window.Rekindle.phase1.emit(
      "recommendation_viewed",
      {

        entity_type:
          entity.entity_type ||
          "recommendation",

        entity_id:
          entity.entity_id ||
          null,

        event_properties: {

          recommendation_id:
            entity.recommendation_id ||
            null,

          source:
            entity.source ||
            null

        }

      }
    );

  };

// ------------------------------------------------------------
// TGC — JOURNEY EXPERIENCE EVENT BINDINGS
// Intent + Recommendation Interactions
// ------------------------------------------------------------

window.Rekindle.phase1.bindJourneyExperienceEvents =
  function () {

    if (
      window.Rekindle.phase1
        ._journeyExperienceEventsBound
    ) {
      return;
    }

    window.Rekindle.phase1
      ._journeyExperienceEventsBound =
      true;


    // ----------------------------------------------------------
    // INTENT DECLARED
    // ----------------------------------------------------------

    document.addEventListener(
      "click",
      function (event) {

        const intentCard =
          event.target.closest(
            ".tgc-intent-card[data-intent-key]"
          );

        if (!intentCard) {
          return;
        }


        const intentKey =
          intentCard.getAttribute(
            "data-intent-key"
          );


        if (!intentKey) {
          return;
        }


        window.Rekindle.phase1.emit(
          "intent_declared",
          {

            entity_type:
              "intent",

            entity_id:
              intentKey,

            entity_name:
              intentKey,

            event_properties: {

              value:
                intentKey,

              intent_value:
                intentKey,

              source:
                "explicit_click"

            }

          }
        );

      },
      true
    );


    // ----------------------------------------------------------
    // RECOMMENDATION CLICKED
    // ----------------------------------------------------------

    document.addEventListener(
  "click",
  function (event) {

    const recommendationLink =
      event.target.closest(
        "[data-recommendation-product-link]"
      );

    if (!recommendationLink) {
      return;
    }


    const recommendationSetId =
      recommendationLink.getAttribute(
        "data-recommendation-set-id"
      ) ||
      null;


    const productId =
      recommendationLink.getAttribute(
        "data-product-id"
      ) ||
      null;


    if (!productId) {
      return;
    }


    window.Rekindle.phase1
      .trackRecommendationClicked(
        {

          entity_type:
            "product",

          entity_id:
            productId,

          recommendation_id:
            recommendationSetId,

          recommendation_set_id:
            recommendationSetId,

          source:
            window.Rekindle
              .resolveExperience()

        }
      );

  },
  true
);
  };
// ------------------------------------------------------------
// FAQ VIEWED
// ------------------------------------------------------------

window.Rekindle.phase1.trackFaqViewed =
  function (faq = {}) {

    return window.Rekindle.phase1.emit(
      "faq_viewed",
      {

        entity_type: "faq",

        entity_id:
          faq.id ||
          faq.question ||
          null,

        entity_name:
          faq.question ||
          null,

        event_properties: {

          question:
            faq.question ||
            null

        }

      }
    );

  };


// ------------------------------------------------------------
// REVIEW VIEWED
// ------------------------------------------------------------

window.Rekindle.phase1.trackReviewViewed =
  function (review = {}) {

    return window.Rekindle.phase1.emit(
      "review_viewed",
      {

        entity_type: "review",

        entity_id:
          review.id ||
          null,

        event_properties: {

          product_id:
            review.product_id ||
            null

        }

      }
    );

  };


// ------------------------------------------------------------
// SHOPIFY COMMERCE EVENT BINDINGS
// ------------------------------------------------------------

window.Rekindle.phase1.bindShopifyCommerceEvents =
  function () {

    // Prevent duplicate bindings
    if (window.Rekindle.phase1._shopifyCommerceBound) {
      return;
    }

    window.Rekindle.phase1._shopifyCommerceBound = true;

    let addToCartPending = false;

    // ----------------------------------------------------------
    // ADD TO CART
    // Handles:
    // - Shopify product-page add to cart
    // - Shopify quick-add
    // - Cart drawer AJAX add
    // ----------------------------------------------------------

    async function detectAddToCart() {

      if (addToCartPending) {
        return;
      }

      addToCartPending = true;

      try {

        const before =
          await window.Rekindle.getCartContext();

        const beforeItems =
          before?.items || [];

        const beforeQuantities = {};

        beforeItems.forEach(function (item) {
          const key =
            String(
              item.variant_id ||
              item.product_id
            );

          beforeQuantities[key] =
            item.quantity || 0;
        });

        // Give Shopify time to complete the AJAX cart update
        await new Promise(function (resolve) {
          setTimeout(resolve, 400);
        });

        const after =
          await window.Rekindle.getCartContext();

        const afterItems =
          after?.items || [];

        let addedItem = null;

        for (
          let i = 0;
          i < afterItems.length;
          i++
        ) {

          const item = afterItems[i];

          const key =
            String(
              item.variant_id ||
              item.product_id
            );

          const beforeQuantity =
            beforeQuantities[key] || 0;

          const afterQuantity =
            item.quantity || 0;

          if (afterQuantity > beforeQuantity) {

            addedItem = {
              product_id: item.product_id,
              variant_id: item.variant_id,
              title: item.title,
              quantity:
                afterQuantity - beforeQuantity,
              price: item.price
            };

            break;
          }
        }

        if (addedItem) {

          window.Rekindle.phase1.trackAddToCart(
            addedItem
          );

          await window.Rekindle.attachIdentityToCart();

        }

      } catch (error) {

        console.warn(
          "⚠️ Rekindle add_to_cart detection failed",
          error
        );

      } finally {

        addToCartPending = false;

      }
    }


    // ----------------------------------------------------------
    // Detect both normal product forms and quick-add buttons
    // ----------------------------------------------------------

    document.addEventListener(
      "submit",
      function (event) {

        const form = event.target;

        if (!form) {
          return;
        }

        const action =
          form.getAttribute("action") || "";

        if (
          action.includes("/cart/add")
        ) {
          detectAddToCart();
        }

      },
      true
    );


    document.addEventListener(
      "click",
      function (event) {

        const button =
          event.target.closest(
            'button[name="add"], ' +
            'button[id*="quick-add"], ' +
            'button[type="submit"][name="add"]'
          );

        if (!button) {
          return;
        }

        // Shopify handles the actual AJAX cart update.
        // We inspect the cart after Shopify completes it.
        detectAddToCart();

      },
      true
    );


    // ----------------------------------------------------------
    // CHECKOUT STARTED
    // ----------------------------------------------------------

    document.addEventListener(
      "click",
      async function (event) {

        const checkoutButton =
          event.target.closest(
            "#CartDrawer-Checkout, " +
            "button[name='checkout'], " +
            "a[href*='/checkout']"
          );

        if (!checkoutButton) {
          return;
        }

        try {

          // Refresh cart first so checkout_started
          // contains the current cart state.
          await window.Rekindle.getCartContext();

          window.Rekindle.phase1.trackCheckoutStarted();

        } catch (error) {

          console.warn(
            "⚠️ Rekindle checkout_started detection failed",
            error
          );

          // Still emit the event even if cart refresh fails.
          window.Rekindle.phase1.trackCheckoutStarted();

        }

      },
      true
    );

  };

  // ------------------------------------------------------------
// PHASE 1 INITIALIZATION
// ------------------------------------------------------------

window.Rekindle.phase1.initialize =
  function () {

    window.Rekindle.phase1
      .trackReturnVisit();

    window.Rekindle.phase1
      .trackIdentityResolved();

    window.Rekindle.phase1
      .trackCartViewed();

    window.Rekindle.phase1
      .trackContentViewed();

    window.Rekindle.phase1
      .bindShopifyCommerceEvents();

    window.Rekindle.phase1
      .bindJourneyExperienceEvents();

  };
window.Rekindle.interpret = async function () {
const experience = window.Rekindle.resolveExperience();

  // ✅ v0.4 — open the journey FIRST, with identity + acquisition ready,
  // so every event below is observed into a properly-seeded journey and
  // first-touch attribution is captured correctly.
  window.Rekindle.getRekindleId();       // who they are
  window.Rekindle.collectEnvironment();  // where they came from
  window.Rekindle.journey.start();       // open / resume the journey

  if (experience === "product_page") {
    window.Rekindle.getProductContext();
    window.Rekindle.getVariantContext();
  }
  const searchEvent =
  window.Rekindle.trackSearchPerformed();

if (searchEvent) {

  window.Rekindle.gtm.push(
    searchEvent
  );

}
window.Rekindle.phase1.initialize();
if (experience === "collection_page") {

  const collectionEvent =
    window.Rekindle.trackCollectionView();

  if (collectionEvent) {

    window.Rekindle.gtm.push(
      collectionEvent
    );

  }

}
if (experience === "product_page") {

  const productEvent =
    window.Rekindle.trackProductView();

  if (productEvent) {

    window.Rekindle.gtm.push(
      productEvent
    );

  }

}
  // Get customer context on every page
  window.Rekindle.getCustomerContext();
  await window.Rekindle.getCartContext();
  await window.Rekindle.attachIdentityToCart();

  // ✅ v0.4 — the duplicate page_view call and the duplicate
  // trackCollectionView block that used to sit here have been removed.
  // (Environment + journey.start now happen at the top of interpret.)

// --------------------------------------
// GTM — Canonical Page View
// --------------------------------------

const pageViewEvent =
  window.Rekindle.recordInteraction("page_view", {

    entity_type:
      experience.replace("_page", ""),

    entity_id:
      window.Rekindle.resolveEntityId(),

    event_properties: {

      channel:
        window.Rekindle.audience.context
          .discovery?.channel || null,

      platform:
        window.Rekindle.audience.context
          .discovery?.platform || null,

      referrer:
        window.Rekindle.audience.context
          .discovery?.referrer || null,

      landing_page:
        window.Rekindle.audience.context
          .discovery?.landing_page || null,

      utm_source:
        window.Rekindle.audience.context
          .discovery?.utm?.source || null,

      utm_medium:
        window.Rekindle.audience.context
          .discovery?.utm?.medium || null,

      utm_campaign:
        window.Rekindle.audience.context
          .discovery?.utm?.campaign || null,

      utm_content:
        window.Rekindle.audience.context
          .discovery?.utm?.content || null,

      utm_term:
        window.Rekindle.audience.context
          .discovery?.utm?.term || null

    }

  });

window.Rekindle.gtm.push(pageViewEvent);

  window.Rekindle.learn({
    behaviour: {
      current_experience: experience
    }
  });
  await window.Rekindle.think();
  await window.Rekindle.sync();
};
window.Rekindle.getProductContext = function () {

  if (!window.meta || !window.meta.product) return null;

  const product = window.meta.product;

  const context = {
    id: product.id,
    gid: product.gid,
    title: document.querySelector('h1')?.textContent.trim(),
    handle: product.handle,
    vendor: product.vendor,
    type: product.type
  };

  window.Rekindle.learn({
    commerce: {
      product: context
    }
  });

  const productEntity =
    window.Rekindle.operations.create(
        "product",
        context.handle
    );

  productEntity.identity = {

    id: context.id,

    gid: context.gid,

    handle: context.handle,

    title: context.title,

    vendor: context.vendor,

    type: context.type

};

window.Rekindle.operations.register(productEntity);

  window.Rekindle.touchContext("commerce");

  console.log("🛍 Product Context", context);

  return context;

};


window.Rekindle.getVariantContext = function () {

  if (!window.meta || !window.meta.product) return null;

  const variantId =
    Number(new URLSearchParams(location.search).get("variant")) ||
    Number(document.querySelector('input[name="id"]')?.value);

  const variant = window.meta.product.variants.find(
    v => v.id === variantId
  );

  if (!variant) return null;

  window.Rekindle.learn({
    commerce: {
      variant: {
        id: variant.id,
        sku: variant.sku,
        title: variant.public_title,
        price: variant.price
      }
    }
  });

  console.log("🧴 Variant Context", variant);

  return variant;

};
window.Rekindle.getCustomerContext = function () {

  if (!window.RekindleCustomer) return null;

  var context = {
    logged_in: window.RekindleCustomer.logged_in,
    id: window.RekindleCustomer.id,
    email: window.RekindleCustomer.email,
    tags: window.RekindleCustomer.tags
  };

  console.log("👤 Customer Context", context);

  window.Rekindle.learn({
    identity: {
        customer: context
    }
});

  return context;

};
window.Rekindle.getCartContext = async function () {

  try {

    const response = await fetch("/cart.js");
    const cart = await response.json();

    var context = {
      token: cart.token,
      item_count: cart.item_count,
      total_price: cart.total_price / 100,
      currency: cart.currency,
      items: cart.items.map(function(item) {
        return {
          product_id: item.product_id,
          variant_id: item.variant_id,
          title: item.product_title,
          variant: item.variant_title,
          sku: item.sku,
          quantity: item.quantity,
          price: item.price / 100
        };
      })
    };

    console.log("🛒 Cart Context", context);

    window.Rekindle.learn({
      commerce: {
        cart: context
      }
    });

    return context;

  } catch (e) {
    console.error("Unable to load cart", e);
  }

};
window.Rekindle.attachIdentityToCart = async function () {

  const rekindleId = window.Rekindle.getRekindleId();
  const session = window.Rekindle.audience.memory.session;

  if (!rekindleId || !session?.id) {
    return;
  }

  try {

    const response = await fetch(
      window.Shopify.routes.root + "cart/update.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            rekindle_id: rekindleId,
            rekindle_session_id: session.id
          }
        })
      }
    );

    if (!response.ok) {
      console.warn(
        "⚠️ Rekindle cart identity update failed",
        response.status
      );
      return;
    }

    console.log("🧠 Rekindle identity attached to cart", {
      rekindle_id: rekindleId,
      session_id: session.id
    });

  } catch (error) {

    console.error(
      "Rekindle cart identity update failed",
      error
    );

  }
};
window.Rekindle.identify = function (identity = {}) {

  window.Rekindle.learn({
    identity: identity
  });

  console.log("👤 Identity Updated", identity);

};
document.addEventListener("DOMContentLoaded", async function () {

  // ✅ v0.4 — detect the host platform at runtime (not hardcoded)
  window.Rekindle.kernel.platform = window.Rekindle.detectPlatform();

  const saved = localStorage.getItem("rekindle_context");

  if (saved) {
    window.Rekindle.audience.context = JSON.parse(saved);
  }
  window.Rekindle.sessions.start();
  await window.Rekindle.interpret();

  window.Rekindle.kernel.initialized = true;

console.log(
  "🔥 Rekindle OS v" +
  window.Rekindle.kernel.version +
  " (" +
  window.Rekindle.kernel.codename +
  ") Ready"
);

console.log(window.Rekindle);

});

window.Rekindle.sync = async function () {

window.Rekindle.kernel.sync.pending = true;

window.Rekindle.kernel.sync.last_sync =
    new Date().toISOString();

window.Rekindle.kernel.sync.sequence++;

  try {

    const payload = {

      payload_meta: {

            sequence: window.Rekindle.kernel.sync.sequence,

            generated_at: new Date().toISOString(),

            sdk_version: window.Rekindle.kernel.version,

            journey_schema_version: window.Rekindle.journey.SCHEMA_VERSION   // ✅ v0.4

        },

  timestamp: new Date().toISOString(),

  sdk_version: window.Rekindle.kernel.version,

  identity: window.Rekindle.audience.identity,

  memory: window.Rekindle.audience.memory,

  context: window.Rekindle.audience.context,

  intelligence: window.Rekindle.audience.intelligence,

  journey: window.Rekindle.journey.getJourney(),   // ✅ v0.4 — send the journey to Make

  operations: {
    entities: window.Rekindle.operations.entities
}
};
console.log("SYNC PAYLOAD");
console.log(payload);

console.log("IDENTITY");
console.log(window.Rekindle.audience.identity);

console.log("OPERATIONS");
console.log(window.Rekindle.operations);

    const response = await fetch(
      "https://hook.us2.make.com/xqwtufee72nb1yd78aqsugqa5prpxm12",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      }
    );

    if (response.ok) {
    window.Rekindle.kernel.sync.last_success =
        new Date().toISOString();

    console.log("☁️ Rekindle synced", response.status);
    }   else {
    console.warn("⚠️ Rekindle sync returned", response.status);
    }

window.Rekindle.kernel.sync.pending = false;

  } catch (error) {

    console.error("Rekindle sync failed", error);
    window.Rekindle.kernel.sync.pending = false;

  }

};
})();
